import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationError, RedirectCommand, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ERROR_PATH } from './app.routes';

export const handleNavigationError = (navigationError: NavigationError): RedirectCommand => {
  const status = navigationError.error instanceof HttpErrorResponse ? navigationError.error.status : 0;
  inject(NGXLogger).error(`Navigation to ${navigationError.url} failed (status ${status})`);
  return new RedirectCommand(inject(Router).parseUrl('/' + ERROR_PATH));
};
